/* sg-expo-calendar: mantiene el estado (Hoy / Ya pasó / Próximo) de cada fecha según el reloj del visitante. */
if (!customElements.get('sg-expo-calendar')) {
  class SgExpoCalendar extends HTMLElement {
    connectedCallback() {
      this.steps = [...this.querySelectorAll('[data-sg-step]')];
      this.skew = this.dataset.serverNow ? Number(this.dataset.serverNow) * 1000 - Date.now() : 0;
      this.update();
      this.timer = setInterval(() => this.update(), 30000);
    }

    disconnectedCallback() {
      clearInterval(this.timer);
    }

    update() {
      const now = Date.now() + this.skew;
      this.steps.forEach((step) => {
        const end = step.dataset.end ? Date.parse(step.dataset.end) : Infinity;
        const start = step.dataset.start ? Date.parse(step.dataset.start) : -Infinity;
        let state = 'next';
        if (now > end) state = 'past';
        else if (now >= start) state = 'now';
        if (step.dataset.state === state) return;
        step.dataset.state = state;
        const label = { now: this.dataset.labelNow, past: this.dataset.labelPast, next: this.dataset.labelNext }[state];
        step.querySelector('[data-sg-step-label]').textContent = label;
      });
    }
  }

  customElements.define('sg-expo-calendar', SgExpoCalendar);
}
